const styles = {
  page: {
    display: "flex",
    gap: 24,
    padding: "24px",
    fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    background: "#f0f2f5",
    minHeight: "100vh",
  },
  left: {
    flex: "1 1 65%",
    background: "#fff",
    padding: "32px",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  right: {
    flex: "0 0 350px",
    position: "sticky",
    top: "24px",
    height: "fit-content",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    paddingBottom: "24px",
    borderBottom: "1px solid #e5e7eb",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#111827",
    margin: 0,
  },
  tabsContainer: {
    display: "flex",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    overflow: "hidden",
    marginBottom: "16px",
  },
  tab: {
    flex: 1,
    padding: "12px",
    textAlign: "center",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    color: "#6b7280",
    background: "#f9fafb",
    borderRight: "1px solid #e5e7eb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.2s",
  },
  activeTab: {
    background: "#fff",
    color: "#111827",
    fontWeight: "600",
  },
  subOption: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    padding: "16px",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "background 0.2s",
    marginBottom: "8px",
  },
  activeSubOption: {
    background: "#f0f7ff",
    border: "1px solid #00a88444",
  },
  radioCircle: {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    border: "2px solid #d1d5db",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "2px",
  },
  radioCircleActive: {
    borderColor: "#00a884",
  },
  radioDot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: "#00a884",
  },
  subOptionContent: {
    flex: 1,
  },
  subOptionTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#111827",
    marginBottom: "2px",
  },
  subOptionDesc: {
    fontSize: "12px",
    color: "#6b7280",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151",
    marginBottom: "4px",
    display: "block",
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s",
    boxSizing: "border-box",
  },
  textarea: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    minHeight: "120px",
    resize: "vertical",
    fontFamily: "inherit",
    boxSizing: "border-box",
  },
  helper: {
    fontSize: "12px",
    color: "#6b7280",
    marginTop: "4px",
  },
  button: {
    background: "#00a884",
    color: "#fff",
    border: "none",
    padding: "12px 24px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
    transition: "background 0.2s",
  },
  secondaryButton: {
    background: "transparent",
    color: "#00a884",
    border: "1px solid #00a884",
    padding: "8px 16px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "13px",
  },
  // Preview Styles
  previewHeader: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#4b5563",
    marginBottom: "16px",
  },
  previewContainer: {
    background: "#e5ddd5",
    padding: "20px",
    borderRadius: "12px",
    backgroundImage: "url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')",
    backgroundSize: "contain",
  },
  messageBubble: {
    background: "#fff",
    borderRadius: "8px",
    padding: "8px",
    boxShadow: "0 1px 0.5px rgba(0,0,0,0.13)",
    maxWidth: "100%",
    position: "relative",
  },
  previewMedia: {
    width: "100%",
    borderRadius: "6px",
    marginBottom: "8px",
    aspectRatio: "16/9",
    objectFit: "cover",
    background: "#f0f0f0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  previewHeaderText: {
    fontWeight: "700",
    fontSize: "14px",
    marginBottom: "4px",
    color: "#111",
  },
  previewBody: {
    fontSize: "14px",
    color: "#111",
    lineHeight: "1.4",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  previewFooter: {
    fontSize: "12px",
    color: "#667781",
    marginTop: "4px",
  },
  previewTime: {
    fontSize: "11px",
    color: "#667781",
    textAlign: "right",
    marginTop: "2px",
  },
  previewButtons: {
    marginTop: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    borderTop: "1px solid #f0f0f0",
  },
  previewButton: {
    padding: "10px",
    textAlign: "center",
    color: "#00a884",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "default",
    background: "#fff",
    borderBottom: "1px solid #f0f0f0",
    "&:last-child": {
      borderBottom: "none",
      borderRadius: "0 0 8px 8px",
    }
  },
  sampleGrid: {
    background: "#f9fafb",
    padding: "16px",
    borderRadius: "8px",
    marginTop: "8px",
    border: "1px solid #f3f4f6",
  },
  sampleRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "8px",
  },
  variableBadge: {
    background: "#e5e7eb",
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "600",
    minWidth: "40px",
    textAlign: "center",
  }
};

export default styles;
